import * as R from 'ramda';

export default function DepartmentProceduresController(
  $q,
  $filter,
  $scope,
  bcpDataService,
  loaderService,
  editDepartmentProceduresDialog,
  ssDialogService,
  userService
) {
  const vm = this;

  vm.hasData = false;

  vm.handleExpand = _handleExpand;
  vm.handleEditDepartmentProcedures = _handleEditDepartmentProcedures;

  _activate();

  /** *********************************************
   * Event Handlers
   */

  function _activate() {
    _initPermissions();
  }

  function _initPermissions() {
    vm.canExpand = true;
    return userService.getUserPermissionSet('bcp').then((permissions) => {
      vm.permissions = permissions;
    });
  }

  function _handleExpand() {
    if (!vm.hasData) {
      return _loadDepartmentProcedures();
    }
    return Promise.resolve();
  }

  function _handleEditDepartmentProcedures($event) {
    _loadDepartmentProcedures().then(() => _openEditDepartmentProceduresDialog($event, {
      assessmentId: vm.assessmentId,
      processes: vm.processes,
    }));
  }

  /** *********************************************
   * Private Functions
   */

  function _loadDepartmentProcedures() {
    loaderService.showViewLoader = true;
    return bcpDataService.getDocumentProcedureByUser(vm.assessmentId)
      .then((response) => {
        loaderService.showViewLoader = false;
        vm.hasData = true;
        vm.processes = R.reject(R.propEq('nameContainsIT', true), response.data.result);
      });
  }

  function _openEditDepartmentProceduresDialog($event, locals) {
    ssDialogService.dialogs.bcp.editDepartmentProceduresDialog = ssDialogService.alert(
      editDepartmentProceduresDialog.getOptions($event, locals)
    );
    return ssDialogService.show(ssDialogService.dialogs.bcp.editDepartmentProceduresDialog);
  }
}

DepartmentProceduresController.$inject = [
  '$q',
  '$filter',
  '$scope',
  'bcpDataService',
  'loaderService',
  'editDepartmentProceduresDialog',
  'ssDialogService',
  'userService'
];
